<template>
  <div class="analyze">
    <div class="center-x-y">
      <h1>Análise</h1>
    </div>
    <div class="input-search">
      <v-text-field v-model="search" outlined append-icon="mdi-magnify" />
    </div>
    <v-data-table
      :headers="headers"
      :items="getAnalyze"
      :search="search"
      class="elevation-1"
    >
      <!-- Ignorar esse erro pq o eslint é bugado -->
      <template v-slot:item.actions="{ item }">
        <v-icon small class="icon mr-4" @click.prevent="_edit(item)"
          >mdi-image-search-outline</v-icon
        >
      </template>
    </v-data-table>

    <dialog-monitoring />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "analyze",
  data: () => ({
    search: null,

    headers: [
      {
        text: "Data",
        align: "start",
        value: "date",
        sortable: false
      },
      { text: "Agriculor", value: "name" },
      { text: "CPF", value: "cpf" },
      { text: "Cultivares", value: "cultivars" },
      { text: "Ações", value: "actions" }
    ]
  }),
  components: {
    "dialog-monitoring": () => import("../components/dialog/index.vue")
  },
  computed: {
    ...mapGetters({
      getAnalyze: "monitoring/getAnalyze"
    })
  },
  methods: {
    ...mapActions({
      actionShowDialog: "dialog/actionShowDialog",
      actionSetItem: "dialog/actionSetItem"
    }),

    _edit(item) {
      this.actionSetItem(item.id);
      this.actionShowDialog();
    }
  }
};
</script>
<style lang="scss" scoped>
.title {
  margin: 1rem 0 1rem 0;
}
.input-search {
  max-width: 50%;
}
@media only screen and (max-width: 600px) {
  .input-search {
    max-width: 300px;
  }
}
@media only screen and (min-width: 1000px) {
  .input-search {
    max-width: 30%;
  }
}
</style>
